var generic = generic || {};
var site = site || {};

(function ($) {
  Drupal.behaviors.productReplenishmentSelectV2 = {
    attach: function (context) {
      // Add replenishment menu event if enable_replenishment=true in config.
      if (!Drupal.settings.common || !Drupal.settings.common.has_replenishment) {
        return null;
      }
     
      var $addBtn = $('.js-product .js-add-to-cart', context);
      var $replenishment = $('.js-product-replenishment', context);
      var $replenishmentSelect = $('.js-product-replenishment-select', $replenishment);
      var $replenishmentLink = $('.js-product-replenishment-link', $replenishment);
      var $replenishmentOptions = $('.js-product-replenishment-options', $replenishment);
      var $replenishmentToggle = $('.js-product-replenishment__toggle', $replenishment);
      var replenishmentContent;

      // When the replenishment select changes, update the add-to-bag
      // button's data-replenishment value.
      $replenishmentSelect.on('change', function () {
        $addBtn.attr('data-replenishment', this.value);
      });

      $replenishmentToggle.change(function () {
        var $element = $(this);
        $replenishmentOptions.toggleClass('hidden');
        var $replenishmentSelectOptions = $('select.' + $(this).val(), $replenishment);
        if ($replenishmentSelectOptions.length > 0) {
          $addBtn.attr('data-replenishment', $replenishmentSelectOptions.val());
        } else {
          if ($element.is(':checked')) {
            $addBtn.attr('data-replenishment', $replenishmentSelect.children('option:selected').val());
          } else {
            $addBtn.attr('data-replenishment', $(this).val());
          }
        }
      });

      // Set add-to-bag default replenishment value to 0.
      $addBtn.attr('data-replenishment', 0);

      $replenishmentLink.once().on('click', function (e) {
        e.preventDefault();
        if (typeof site.templates !== 'undefined' && typeof site.templates.product_replenishment_overlay !== 'undefined') {
          replenishmentContent = site.template.get({ name: 'product_replenishment_overlay' });
          generic.overlay.launch({
            html: replenishmentContent
          });
        }
      });
    }
  };
})(jQuery);
